import { createFileRoute } from "@tanstack/react-router";

import MessengerFullscreen from "../../../../../components/MessengerFullscreen";
import MessengerFullscreenSkeleton from "../../../../../components/MessengerFullscreenSkeleton";
import {
  fetchConversationMessagesQueryOptions,
  fetchGroupInviteQueryOptions,
} from "../../../../../services";

export const Route = createFileRoute(
  "/_panel/_messenger/messenger/groups/join/$token",
)({
  loader: async (opts) => {
    const preview = await opts.context.queryClient.ensureQueryData(
      fetchGroupInviteQueryOptions(opts.params.token),
    );
    if (preview?.conversation?.id) {
      await opts.context.queryClient.prefetchInfiniteQuery(
        fetchConversationMessagesQueryOptions(preview.conversation.id),
      );
    }
  },
  component: GroupJoinPage,
  pendingComponent: MessengerFullscreenSkeleton,
});

function GroupJoinPage() {
  const { token } = Route.useParams();

  return (
    <div className="-m-4 h-[calc(100dvh-4rem)] overflow-hidden sm:-m-6 sm:-mb-32 sm:h-dvh">
      <MessengerFullscreen joinToken={token} />
    </div>
  );
}
